import { RevenueConfig } from '../../dashboard-config';
import type { DashboardConfig } from '../types';
import { useDashboardConfigForm } from '../hooks/useDashboardConfigForm';
import { ConfigDialogShell } from './ConfigDialogShell';

interface RevenueTileConfigDialogProps {
  open: boolean;
  onClose: () => void;
  dashboardConfig: DashboardConfig;
  onSave: (config: DashboardConfig) => Promise<void>;
  reloadConfig: () => Promise<DashboardConfig>;
}

const METHOD_LABEL = {
  START_DATE: 'Start date within the range',
  END_DATE: 'End date within the range',
  EITHER_DATE: 'Either start or end date within the range',
};

export function RevenueTileConfigDialog({
  open,
  onClose,
  dashboardConfig,
  onSave,
  reloadConfig,
}: RevenueTileConfigDialogProps) {
  const { form, values, patch, submit, saving, error } = useDashboardConfigForm({
    open,
    onClose,
    dashboardConfig,
    onSave,
    reloadConfig,
  });
  return (
    <ConfigDialogShell
      open={open}
      title="Configure Revenue Tile"
      onClose={onClose}
      onSave={submit}
      saving={saving}
      saveLabel={form.saveLabel('Save')}
      banner={form.banner}
      error={error}
      note={
        form.field('revenueCalculationMethod', { format: (v) => METHOD_LABEL[v] }).helperText
      }
    >
      <RevenueConfig
        value={values.revenueCalculationMethod}
        onChange={(value) => patch({ revenueCalculationMethod: value })}
        variant="compact"
      />
    </ConfigDialogShell>
  );
}
